import React from 'react';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="31aqeoda66opo">
      <CountdownBar data-id="element-1" data-mp="31brzvakwgrl4" />
      <main data-id="element-2" data-mp="31c1hoavsjsfq">
        <Hero data-id="element-3" data-mp="31ctflscv2296" />
        <StatsBar data-id="element-4" data-mp="2wk08wyxu0jug" />
        <Difference data-id="element-5" data-mp="2wjgrrkg09zhh" />
        <WhatsInside data-id="element-6" data-mp="2wiyvintcfl9k" />
        <InsidePages data-id="element-7" data-mp="2wip6b2g4hi4x" />
        <Bonuses data-id="element-8" data-mp="2wi5lndz38fn7" />
        <Offer data-id="element-9" data-mp="28u5zkrcq1dey" />
        <Testimonials data-id="element-10" data-mp="28tmfp53igeya" />
        <Faq data-id="element-11" data-mp="28t4k8aooa4rf" />
      </main>
      <Footer data-id="element-12" data-mp="28sb9kymlev40" />
    </div>;
}